import { GraphQLResult } from "@aws-amplify/api-graphql";
import { RestoreTwoTone } from "@material-ui/icons";
import { ListBoothBoatBrandsQuery, ListBoothBoatTypesQuery } from "API";
import { API, graphqlOperation } from "aws-amplify";
import Select from "components/atoms/CmSelect";
import { listBoothBoatTypes } from "graphql/queries";
import * as React from "react";

type Props = {
  value: string;
  // value: any;
  onChange: any;
};

type Options = {
  name?: string;
  value?: string;
};

export default function SelectPrice(props: Props) {
  const { value, onChange, ...rest } = props;
  const [myValue, setMyValue] = React.useState("");
  const [options, setOptions] = React.useState<Options[]>([
    { name: "指定なし", value: "" },
    { name: "200万円", value: "200" },
    { name: "500万円", value: "500" },
    { name: "1000万円", value: "1000" },
    { name: "3000万円", value: "3000" },
  ]);

  // async function getBrand() {
  //   const res = (await API.graphql(
  //     graphqlOperation(listBoothBoatTypes),
  //     {}
  //   )) as GraphQLResult<ListBoothBoatTypesQuery>;
  //   const types = res?.data?.listBoothBoatTypes?.items;
  //   if (types && types?.length > 0) {
  //     const _options = types.map((item) => {
  //       return { name: item?.name, value: item?.name };
  //     });
  //     setOptions([...options, ..._options]);
  //   }
  // }

  // React.useEffect(() => {
  //   getBrand();
  // }, []);

  React.useEffect(() => {
    setMyValue(value);
  }, [value]);

  return (
    <Select {...rest} value={myValue} options={options} onChange={onChange} />
  );
}
